module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('header-doc', {
    slot: "header"
  }), _vm._v(" "), _c('menu-examples', {
    slot: "sidebar"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('buttons'), _vm._v(" "), _c('grid'), _vm._v(" "), _c('forms'), _vm._v(" "), _c('icons')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b2a18e74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Guide.vue
// module id = 148
// module chunks = 1